import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../../../features/dropdown/dropdownSlice";
import { Table } from "antd";

function PanelTable() {
  const urlPanelById = "v1/ap/panel/fetchById";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, data, count ,activeObjActivity} = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[urlPanelById] || [],
    count: state.dropdown.count[urlPanelById] || 0,
    activeObjActivity: state.folder.activeObj["activity"],
  }));

   

  const columns = [
    {
      title: "Member Name",
      dataIndex: "pmName",
    },
    {
      title: "Member Roles",
      dataIndex: "pmRole",
    },
    {
      title: "Email",
      dataIndex: "pmEmail",
    },
    {
      title: "Phone Number",
      dataIndex: "pmPhone",
    },
  ];

  const tableColumns = columns?.map((item) => ({
    ...item,
  }));

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: urlPanelById,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        paId:activeObjActivity?.jaaPaId
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []); 
  return (
    <>
      {data && data?.map((panel) => (
        <div className="border border-[#DBE1EE] rounded-[.75rem] lg:p-[1.5rem] p-[.8rem] mt-[1.5rem]">
          <Table
            key={panel.paId}
            rowSelection={false}
            size={"middle"}
            bordered={true}
            pagination={{
              position: ["bottomCenter"],
              hideOnSinglePage: true,
            }}
            rowKey={panel?.paId}
            columns={tableColumns}
            dataSource={panel?.panelMembers || []}
            scroll={{
              x: "auto",
            }}
            className="custom-table mt-[2rem]"
            loading={loading}
            title={(record) => {
              return (
                <div className="flex items-center justify-between">
                  <div className="text-[#0B363D] font-dmSans text-[1.125rem] font-[500]">
                    {panel?.paName}
                  </div>
                </div>
              );
            }}
          />
        </div>
      ))}
    </>
  );
}

export default PanelTable;
